module.exports = __webpack_public_path__ + "SarahM.png?14752ebc1f180e9b36c1e1234027a501";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customers/SarahM.png
// module id = 78
// module chunks = 0